import PropTypes from 'prop-types';
import { DatePicker } from '@mui/x-date-pickers-pro';

const SalesforceTaskDueDatePicker = ({
	value,
	onChange,
	validation,
	disabled = false,
	showError = false,
	testId = 'task-due-date-input',
}) => {
	return (
		<DatePicker
			value={value}
			onChange={onChange}
			disabled={disabled}
			minDate={validation.minDate}
			maxDate={validation.maxDate}
			slotProps={{
				textField: {
					size: 'small',
					fullWidth: true,
					error: showError && !validation.isValid,
					helperText:
						showError && !validation.isValid
							? validation.errorMessage
							: ' ',
					inputProps: {
						'data-testid': testId,
					},
					sx: {
						'& .MuiInputBase-root': {
							backgroundColor: 'background.paper',
						},
						'& .MuiFormHelperText-root': {
							fontSize: '10px',
							marginLeft: 0,
							height: '4px',
							margin: 0,
							padding: '1px',
						},
					},
				},
			}}
		/>
	);
};

SalesforceTaskDueDatePicker.propTypes = {
	value: PropTypes.object,
	onChange: PropTypes.func.isRequired,
	validation: PropTypes.shape({
		isValid: PropTypes.bool.isRequired,
		errorMessage: PropTypes.string,
		formattedValue: PropTypes.string,
		minDate: PropTypes.object.isRequired,
		maxDate: PropTypes.object.isRequired,
	}).isRequired,
	disabled: PropTypes.bool,
	showError: PropTypes.bool,
	testId: PropTypes.string,
};

export default SalesforceTaskDueDatePicker;
